import styled from 'styled-components';

const TRACK_HEIGHT = 4;
const THUMB_SIZE = 16;

export const Wrapper = styled.div`
    --pos: 0%;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    user-select: none;
`;

export const Track = styled.div`
    position: relative;
    flex: 1 1 auto;
    height: ${THUMB_SIZE}px;
    display: flex;
    align-items: center;
    cursor: pointer;
    touch-action: none;
`;

export const Rail = styled.div`
    position: absolute;
    left: 0;
    right: 0;
    height: ${TRACK_HEIGHT}px;
    background: ${(props) => props.theme.root.colors.basicColors['30%']};
    border-radius: ${TRACK_HEIGHT / 2}px;
`;

export const Fill = styled.div`
    position: absolute;
    left: 0;
    height: ${TRACK_HEIGHT}px;
    background: ${(props) => props.theme.root.colors.primary.default};
    border-radius: ${TRACK_HEIGHT / 2}px;
    width: var(--pos);
`;

export const Thumb = styled.div`
    position: absolute;
    width: ${THUMB_SIZE}px;
    height: ${THUMB_SIZE}px;
    border-radius: 50%;
    background: ${(props) => props.theme.root.colors.primary.default};
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
    transform: translateX(-50%);
    left: var(--pos);
`;
